export const bankLists = [
  {
    bank_code: "102",
    bank_name: "Banco de Venezuela, S.A. Banco Universal",
    icon: "BV",
  },
  {
    bank_code: "104",
    bank_name: "Banco Venezolano de Crédito, S.A. Banco Universal",
    icon: "BVC",
  },
  {
    bank_code: "105",
    bank_name: "Banco Mercantil C.A., Banco Universal",
    icon: "BM",
  },
  {
    bank_code: "108",
    bank_name: "Banco Provincial, S.A. Banco Universal",
    icon: "BP",
  },
  {
    bank_code: "114",
    bank_name: "Banco del Caribe C.A., Banco Universal",
    icon: "BC",
  },
  {
    bank_code: "115",
    bank_name: "Banco Exterior C.A., Banco Universal",
    icon: "BE",
  },
  {
    bank_code: "128",
    bank_name: "Banco Caroní C.A., Banco Universal",
    icon: "BCC",
  },
  {
    bank_code: "134",
    bank_name: "Banesco Banco Universal, C.A.",
    icon: "BBU",
  },
  {
    bank_code: "137",
    bank_name: "Banco Sofitasa Banco Universal, C.A .",
    icon: "BSU",
  },
  {
    bank_code: "138",
    bank_name: "Banco Plaza, Banco universal",
    icon: "BP",
  },
  {
    bank_code: "146",
    bank_name: "Banco de la Gente Emprendedora C.A.",
    icon: "BGE",
  },
  {
    bank_code: "151",
    bank_name: "Banco Fondo Común, C.A Banco Universal",
    icon: "BFC",
  },
  {
    bank_code: "156",
    bank_name: "100% Banco, Banco Comercial, C.A",
    icon: "BCC",
  },
  {
    bank_code: "157",
    bank_name: "DelSur, Banco Universal C.A.",
    icon: "DSU",
  },
  {
    bank_code: "163",
    bank_name: "Banco del Tesoro C.A., Banco Universal",
    icon: "BDT",
  },
  {
    bank_code: "166",
    bank_name: "Banco Agrícola de Venezuela C.A., Banco Universal",
    icon: "BAV",
  },
  {
    bank_code: "168",
    bank_name: "Bancrecer S.A., Banco Microfinanciero",
    icon: "BCR",
  },
  {
    bank_code: "169",
    bank_name: "Mi Banco, Banco Microfinanciero, C.A.",
    icon: "MIB",
  },
  {
    bank_code: "171",
    bank_name: "Banco Activo C.A., Banco Universal",
    icon: "BAC",
  },
  {
    bank_code: "172",
    bank_name: "Bancamiga Banco Universal, C.A.",
    icon: "BMG",
  },
  {
    bank_code: "173",
    bank_name: "Banco Internacional de Desarrollo C.A., Banco Universal",
    icon: "BID",
  },
  {
    bank_code: "174",
    bank_name: "Banplus Banco Universal, C.A.",
    icon: "BNP",
  },
  {
    bank_code: "175",
    bank_name: "Banco Bicentenario del Pueblo, Banco Universal C.A",
    icon: "BBP",
  },
  {
    bank_code: "177",
    bank_name: "Banco de la Fuerza Armada Nacional Bolivariana, B.U.",
    icon: "BFA",
  },
  {
    bank_code: "178",
    bank_name: "N58 Banco Digital, Banco Microfinanciero, C.A.",
    icon: "N58",
  },
  {
    bank_code: "191",
    bank_name: "Banco Nacional de Crédito C.A., Banco Universal",
    icon: "BNC",
  },
  {
    bank_code: "601",
    bank_name: "Instituto Municipal de Crédito Popular",
    icon: "IMC",
  },
];

// 0001 Banco Central de Venezuela
// 0102 Banco de Venezuela, S.A. Banco Universal
// 0104 Banco Venezolano de Crédito, S.A. Banco Universal
// 0105 Banco Mercantil C.A., Banco Universal
// 0108 Banco Provincial, S.A. Banco Universal
// 0114 Banco del Caribe C.A., Banco Universal
// 0115 Banco Exterior C.A., Banco Universal
// 0128 Banco Caroní C.A., Banco Universal
// 0134 Banesco Banco Universal, C.A.
// 0137 Banco Sofitasa Banco Universal, C.A .
// 0138 Banco Plaza, Banco universal
// 0146 Banco de la Gente Emprendedora C.A.
// 0151 Banco Fondo Común, C.A Banco Universal
// 0156 100% Banco, Banco Comercial, C.A
// 0157 DelSur, Banco Universal C.A.
// 0163 Banco del Tesoro C.A., Banco Universal
// 0166 Banco Agrícola de Venezuela C.A., Banco Universal
// 0168 Bancrecer S.A., Banco Microfinanciero
// 0169 Mi Banco, Banco Microfinanciero, C.A.
// 0171 Banco Activo C.A., Banco Universal
// 0172 Bancamiga Banco Universal, C.A.
// 0173 Banco Internacional de Desarrollo C.A., Banco Universal
// 0174 Banplus Banco Universal, C.A.
// 0175 Banco Bicentenario del Pueblo, Banco Universal C.A.
// 0177 Banco de la Fuerza Armada Nacional Bolivariana, B.U.
// 0178 N58 Banco Digital, Banco Microfinanciero
// 0191 Banco Nacional de Crédito C.A., Banco Universal
// 0601 Instituto Municipal de Crédito Popular
